
//@ts-ignore
export const baseUrl = import.meta.env.VITE_API_URL;

export const basePicUrl = `${baseUrl}/api/common/tos/url?key=`

export const systemName = '青山任效管理系统';